import { useEnvironment } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { Text } from 'wix-ui-tpa/cssVars';
import { classes, st } from './SubscriptionInfo.st.css';

type SubscriptionInfoProps = {
  text?: string;
};

export const SubscriptionInfo: FC<SubscriptionInfoProps> = ({ text }) => {
  const { isMobile } = useEnvironment();

  if (!text) {
    return null;
  }

  return (
    <div
      data-hook="details-subscription-info"
      className={st(classes.root, { isMobile })}
    >
      <Text className={classes.subscriptionInfo}>{text}</Text>
    </div>
  );
};
